function getFormatter (col, filter) {
  if (!filter) {
    return null
  }
  // 过滤器
  if (col.filter) {
    if (col.filter.type && col.filter.args) {
      let func = filter[col.filter.type]
      if (func) {
        return (row, column, val) => func(val, ...col.filter.args)
      }
    } else {
      // 不显示秒，minute 替换 time
      if (col.filter === 'time') {
        col.filter = 'minute'
      }
      let func = filter[col.filter]
      if (func) {
        // 9级组织
        if (col.filter === 'deptFilter') {
          return (row, column, val) => func(val, column.dept)
        } else {
          return (row, column, val) => func(val)
        }
      }
    }
  }
  return null
}

export function tableCellFormatterResult (context, {
  column,
  rowData,
  rowIndex,
  columnIndex,
  displayText
}) {
  try {
    const filter = context.$filter
    const formatter = getFormatter(column, filter || (context.parent ? context.parent.$filter : null))
    if (formatter) {
      displayText = formatter(rowData, column, displayText)
    }
    if (column.formatter && typeof column.formatter === 'function') {
      displayText = column.formatter(rowData, column, displayText, rowIndex, columnIndex)
    }
    return displayText
  } catch (error) {
    console.error(error)
    return displayText
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/utils/formatter.js